import * as React from 'react';
import useWindowDimensions from '../../../../shared/hooks/useWindowDimensions';

import lottieMapDekstop from '../../assets/skeleton-loaders/map-desktop.png';
import lottieMapTablet from '../../assets/skeleton-loaders/map-tablet.png';
import lottieMapMobile from '../../assets/skeleton-loaders/map-mobile.png';

import lottieListDekstop from '../../assets/skeleton-loaders/list-desktop.png';
import lottieListTablet from '../../assets/skeleton-loaders/list-tablet.png';
import lottieListMobile from '../../assets/skeleton-loaders/list-mobile.png';
import { SCREEN_NORMAL, SCREEN_TABLET } from '../../../../shared/config/constants';
import SkeletonWrapper from '../../../../shared/components/SkeletonWrapper';

interface Props {
  type: 'list' | 'map';
  className?: string;
}

const SkeletonLoader: React.FC<Props> = (props) => {
  const { width } = useWindowDimensions();
  const { type, className } = props;

  const getLoaderPng = () => {
    if (type === 'map') {
      if (width > SCREEN_NORMAL) {
        return lottieMapDekstop;
      }

      if (width > SCREEN_TABLET) {
        return lottieMapTablet;
      }

      return lottieMapMobile;
    }

    if (type === 'list') {
      if (width > SCREEN_NORMAL) {
        return lottieListDekstop;
      }

      if (width > SCREEN_TABLET) {
        return lottieListTablet;
      }

      return lottieListMobile;
    }

    return undefined;
  };

  return (
    <SkeletonWrapper active className={className}>
      <img src={getLoaderPng()} alt="loading" />
    </SkeletonWrapper>
  );
};

export default SkeletonLoader;
